// extracted by mini-css-extract-plugin
export default {"card":"AlbumCart_card__8L6W4","card_content":"AlbumCart_card_content__YBEZn","image_card_content":"AlbumCart_image_card_content__uBZgF"};